module.exports = __webpack_public_path__ + "static/media/mm-logo.9149cc9a.png";


//////////////////
// WEBPACK FOOTER
// ./public/mm-logo.png
// module id = 228
// module chunks = 0